import React from 'react';
import { View, StyleSheet } from 'react-native';
import ImageIcon from '../../../../../../components/shared/Icon/ImageIcon.component';
import colors from '../../../../../../config/colors';
import I18n from '../../../../../../components/shared/i18n/I18n.component';

const MiniCard = (props) => { 

    return (
        <>
            <View style={styles.container}>
                <View style={styles.firstLine}>
                    <I18n size={12} weight='400' color={colors.subtitleColor}>{props.title}</I18n>
                    <View style={styles.iconWrapper}>
                        <ImageIcon name={props.icon} />
                    </View>
                </View>
                <I18n size={17} weight='400' color={colors.darkGrey}>{props.value}</I18n>
            </View>
        </>
    );
}

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        padding: 16,
        gap: 8,
        flex: 1,
        borderRadius: 5,
        backgroundColor: 'white',
    },
    firstLine: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconWrapper: {
        display: 'flex',
        padding: 4,
        alignItems: 'center',
        borderRadius: 6,
        backgroundColor: colors.iconBG,
    }
});


export default MiniCard;